import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {RealmService} from '../Services/Realm/realm.service';
import {ApiService} from '../Services/Api/api.service';
import {environment} from '../../environments/environment';
import {ICardDetails} from 'ng-payment-card/lib/domain/i-card-details';
import {Router} from '@angular/router';
import {MenuItem} from 'primeng/api';
import {MessageService} from 'primeng/api';
@Component({
  selector: 'app-provider-wait',
  templateUrl: './provider-wait.component.html',
  providers: [MessageService],
  styleUrls: ['./provider-wait.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ProviderWaitComponent implements OnInit {
  @Input() quequePosition = 0;
  @Input() quequeTime = '';
  @Input() quequeVariable = '';
  @Input() provider: any;
  copaymentInfo = [];
  typeSelectedProvider = '';
  copayment = false;
  env = environment;
  dialogCreditCard = false;
  paymentSuccess = false;
  isWaiting = false;
  selectedIdProvider = '';
  items: MenuItem[];
  activeIndex = 1;
  constructor(private realm: RealmService, private apiService: ApiService, private router: Router, private messageService: MessageService) { }

  ngOnInit(): void {
    //this.realm.updateScreenProviders(3);
    // this.isWaiting = this.quequePosition > 0;
    // this.selectedIdProvider = this.provider.data[0].idProvider.idProvider;
    this.items = [{
      label: 'Copago',
      command: (event: any) => {
        this.activeIndex = 0;
        // this.messageService.add({severity: 'info', summary: 'First Step', detail: event.item.label});
      },
      routerLink: 'home/orders/checkout'
    },
      {
        label: 'Pago',
        command: (event: any) => {
          this.activeIndex = 1;
          // this.messageService.add({severity: 'info', summary: 'Seat Selection', detail: event.item.label});
        },
        routerLink: 'home/orders/payment'
      },
      {
        label: 'Confirmación',
        command: (event: any) => {
          this.activeIndex = 2;
          // this.messageService.add({severity: 'info', summary: 'Pay with CC', detail: event.item.label});
        },
        routerLink: 'home/orders/confirmation'
      },
      {
        label: 'Lista de Espera',
        command: (event: any) => {
          this.activeIndex = 3;
          // this.messageService.add({severity: 'info', summary: 'Last Step', detail: event.item.label});
        },
        routerLink: 'home/orders/wait'
      }
    ];
  }
  nextPage() {
    this.router.navigate(['steps/Pago']);
  }
  prevPage() {
    this.router.navigate(['steps/Copago']);
  }
  processPayment($event: ICardDetails) {
    // todo si el pago fue procesado exitosamente llamar el api para agregar una persona a la cola. y mostrar dialogo de posicion actual.
    // tslint:disable-next-line:max-line-length
    // todo llamar api para verificar si pago fue realizado y si la llamada fue realizada y finalizada con exito. de lo contrario omitir pago y proceder a espera.
    console.log($event);
    /*cardHolder: "asdfasfasdfa"
​
    cardNumber: "377720745104636"
    ​
    ccv: "123"
    ​
    expirationMonth: "11"
    ​
    expirationYear: "2024"*/
    const statusPayment = true;
    const statusCall = false;
    // this.showWaiting = true;
    this.dialogCreditCard = false;
    this.paymentSuccess = statusPayment && !statusCall;
    if (this.isWaiting && this.paymentSuccess) {
      this.router.navigate(['steps/Confirmación']);
      // this.router.navigate(['home/telemedicine', this.selectedIdProvider, this.typeSelectedProvider]);
    }
  }
}
